module.exports = __webpack_public_path__ + "img/phone-verify.67d7c57.svg";